






import {Component, Prop, Watch} from "vue-property-decorator";
import ProgramMixin from "./mixins/ProgramMixin";
import {RepositoryFabric} from "../../api/repositories/RepositoryFabric";
import { ProgramDataHelper } from "./helpers/ProgramDataHelper"
import {StaticConfigRepository} from "@api/repositories/StaticConfigRepository";

/**
 * Компонент который выполняет переодическую загрузку данных программы
 */
@Component({
    name: 'ProgramRoot',
    components: {  }
})
export default class Program extends ProgramMixin {

    @Prop({required: true}) backend: string;

    @Watch('date')
    async dateChanged() {
        this.startTimer();
    }

    /**
     * Timezone offset from settings
     */
    get offset() {
        return this.$store.state.timeZoneOffset;
    }

    /**
     * dataHelper used realTimeUpdates
     */
    get useRealtimeUpdates(): boolean {
        return this.$store.state.program.useRealtimeUpdates;
    }

    /**
     * Data helper for data manipulation, comes from vuex store by date
     */
    get dataHelper(): ProgramDataHelper | null {
        if (this.date) {
            const dateStr = this.date?.toISODate();
            return this.$store.state.program.programs[dateStr] || {};
        }
        return null;
    }

    async mounted() {
        this.initRefresh(null, null, () => {
            this.fetchData();
        }, ProgramMixin.PROGRAM_ACTIVATE_LIMIT_TIMEOUT);
    }

    async fetchData() {
        // TODO: Убрать код обновления через http-запросы
        if(!this.useRealtimeUpdates) {
            this.dataHelper?.fetchData();

            try {
                const params = await this.$repositories.get<StaticConfigRepository>(RepositoryFabric.STATIC).get(this.backend);
                if (params && params.periodicRefresh && params.periodicRefresh.Program && params.periodicRefresh.Program * 1000 !== this.refreshTimeout) {

                    this.setRefreshFn(() => {
                        (this as any).fetchData(null, false);
                    }, params.periodicRefresh.Program * 1000);
                }
            } catch (error) {
                // do nothing
            }
        }
    }
}
